$(function () {
    $('select[name="occations"]').change(function (e) {
        window.location.href = $(e.target).val();
    });
});
